import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteJobTitleModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobTitleModalContainer" */
      './DeleteJobTitleModalContainer'
    ),
  loading: LoadingModal,
});
